import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "./queryKeys";
import {
  getHotelTypes,
  HotelType,
} from "~/lib/server-functions/get-hotel-types";

export const useHotelTypes = (ids?: number[] | string[]) => {
  // Check if the array contains numbers or strings
  const isNames = ids && ids.length > 0 && typeof ids[0] === "string";
  
  return useQuery<HotelType[]>({
    queryKey: [QUERY_KEYS.HOTEL_TYPES, ids],
    queryFn: async () => {
      if (isNames) {
        const hotelTypes = await getHotelTypes({
          data: { names: ids as string[] },
        });
        return hotelTypes;
      } else {
        const hotelTypes = await getHotelTypes({
          data: ids ? { ids: ids as number[] } : undefined,
        });
        return hotelTypes;
      }
    },
  });
};
